(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Búsqueda actual',
    noCollectionFound: 'Coleccción no encontrada',
    allProducts: 'Ver todos los productos',
    matching: 'matching',
    sortBy: 'Ordenar por',
    relevance: 'Relevancia',
    outOf: 'de',
    resultsFound: 'artículos encontrados',
    oneResultFound: '1 artículo encontrado',
    noResultFound: 'Búsqueda sin resultados',
    addToCart: 'Añadir a la cesta',
    searchForProduct: 'Buscar productos',
    selectedFilter: 'Filtros seleccionados',
    clearAll: 'Borrar todo',
    noPageFound: 'Página no encontrada',
    outOfStock: 'Agotado',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Búsqueda sin resultados: ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Intenta ' +
        render(html_tags[0]) +
        ' limpiar los filtros ' +
        render(html_tags[1]) +
        ' o ' +
        render(html_tags[2]) +
        ' cambiar la búsqueda ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' de'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
